<h3 class="mb-3">{{ name }}'s final declaration application</h3>
<div class="row">
  <div class="col-md-4">
    <div class="form-group">

      <label for="name">Name</label>
      <div class="form-control readonly" [innerHTML]="name">

      </div>
    </div>
  </div>

  <div class="col-md-4">
    <div class="form-group">
      <label for="submittedAt">Designated supervisor's registration number</label>
      <div style="min-height: 40px;" class="form-control readonly" [innerHTML]="tutorRegNumber">
      </div>
    </div>
  </div>


  <div class="col-md-4">
    <div class="form-group">
      <label for="submittedAt">Submitted at</label>
      <div style="min-height: 40px;" class="form-control readonly" [innerHTML]="submittedAt | utcDate">
      </div>
    </div>
  </div>

  <div class="col-md-4">
    <div class="form-group">
      <label for="grade">Outcome</label>
      <div class="form-control readonly"
        [innerHTML]="progressReport?.decision === 999 ? 'Unsatisfactory': 'Satisfactory'">

      </div>
    </div>
  </div>


</div>

<div class="row">
  <div class="col-md-12">
    <div class="form-group">
      <label for="">Supporting text</label>
      <div class="form-control readonly" [innerHTML]="$safeNavigationMigration(progressReport?.feedback)"></div>
    </div>
  </div>
</div>

<div class="row">

  <div class="col-md-12 mb-2">
    <h4>Designated supervisor feedback</h4>
  </div>

  <div class="col-md-12">
    <div class="form-group">

      <label for="tutorFeedback">
        This progress report and outcome has been discussed with a second pharmacy/healthcare professional
      </label>
      <div class="form-control readonly"
        [innerHTML]="countersignerComment?.anyProblemsEffected === true ? 'Yes' : 'No'">

      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div class="form-group">

      <label for="tutorFeedback">
        Add any comments on your trainee’s progress to date, or their developmental needs, that support your decision
        about
        their readiness to register.
      </label>
      <div class="form-control readonly" [innerHTML]="$safeNavigationMigration(countersignerComment?.traineeProgressComments)">

      </div>
    </div>
  </div>

  <div class="col-md-12">
    <div class="form-group">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="">Annual leave</label>
            <div class="form-control readonly" [innerHTML]="$safeNavigationMigration(countersignerComment?.annualLeaves)"></div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="">Sickness</label>
            <div class="form-control readonly" [innerHTML]="$safeNavigationMigration(countersignerComment?.sickLeaves)"></div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="">Other</label>
            <div class="form-control readonly" [innerHTML]="$safeNavigationMigration(countersignerComment?.otherLeaves)"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div class="form-group">

      <label for="tutorFeedback">
        Reason for other leave
      </label>
      <div class="form-control readonly"
        [innerHTML]="countersignerComment?.otherLeaveDetails ? $safeNavigationMigration(countersignerComment?.otherLeaveDetails) : 'No other leave details'">

      </div>
    </div>
  </div>


</div>
@if (!(confirmedTempRegistration===null)) {
  <div class="row">
    <div class="col-md-12 mb-2">
      <h4>Provisional Registration</h4>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <div class="form-control readonly" [innerHTML]="confirmedTempRegistration === true ? 'Yes': 'No'">
        </div>
      </div>
    </div>
  </div>
}
<div class="row">
  <div class="col-md-12 mb-2">
    <h4>Trainee comments</h4>
  </div>
  <div class="col-md-12">
    <div class="form-group">

      <div class="form-control readonly"
        [innerHTML]="countersignerComment?.traineeFeedbackOnTutorAssessment ? $safeNavigationMigration(countersignerComment?.traineeFeedbackOnTutorAssessment) : 'No comments'">

      </div>
    </div>
  </div>
</div>